// Routes
import config from "~/config";

// Pages
import Login from "../Login";
import Registration from "../Registration";
import ActiveAccount from "../ActiveAccount";
import ForgotPassword from "../ForgotPassword";
import ResetPassword from "../ResetPassword";
import Transactions from "../Transactions";
import Ip from "../Ip/Ip";
import Wallets from "../Wallets";
import Terms from "../Terms";

const publicRoutes = [
  { path: config.routes.registration, component: Registration },
  { path: config.routes.login, component: Login },
  { path: config.routes.active, component: ActiveAccount },
  { path: config.routes.forgotPassword, component: ForgotPassword },
  { path: config.routes.resetPassword, component: ResetPassword },
  { path: config.routes.ip, component: Ip },
  { path: config.routes.terms, component: Terms },
];

const privateRoutes = [
  { path: config.routes.profile, component: Wallets },
  { path: config.routes.budget, component: Wallets },
  { path: config.routes.overview, component: Wallets },
  { path: config.routes.transactions, component: Transactions },
  { path: config.routes.wallets, component: Wallets },
];

export { publicRoutes, privateRoutes };
